module.exports = __webpack_public_path__ + "img/google-logo-gray.b0b1861a.svg";